interface AppRouter extends HTMLElement {
  go: (url?: string) => void;
  goBack: () => void;
}

export const store = document.body.querySelector('app-state');
export const signin = document.body.querySelector('app-signin');
export const router = <AppRouter>document.body.querySelector('app-router');
